module.exports = __webpack_public_path__ + "assets/img/amiya.dbcf93e0.gif";